import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/Icons/info.svg'


const _withScopeId = n => (_pushScopeId("data-v-40a5a4c2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "engagement-team-spotlight-user-container" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "left" }
const _hoisted_4 = { class: "middle" }
const _hoisted_5 = { class: "right" }
const _hoisted_6 = { class: "score" }
const _hoisted_7 = { class: "off-black" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "data-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Themes"),
  /*#__PURE__*/_createElementVNode("div", {
    id: "engagement-trend-info",
    class: "title"
  }, [
    /*#__PURE__*/_createTextVNode(" Engagement "),
    /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
  ])
], -1))
const _hoisted_9 = { class: "data-row-score" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "data-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Topics"),
  /*#__PURE__*/_createElementVNode("div", { class: "title" }, "NPS")
], -1))
const _hoisted_11 = {
  key: 0,
  class: "data-row"
}
const _hoisted_12 = {
  key: 1,
  class: "data-row"
}
const _hoisted_13 = { class: "button-container" }
const _hoisted_14 = { class: "button-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AvatarOrInitials = _resolveComponent("AvatarOrInitials")!
  const _component_Typography = _resolveComponent("Typography")!
  const _component_UpDownArrow = _resolveComponent("UpDownArrow")!
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!
  const _component_RainBaseButton = _resolveComponent("RainBaseButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_AvatarOrInitials, {
          size: 60,
          user: _ctx.userDetails
        }, null, 8, ["user"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_Typography, { variant: "h4" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.userData.name), 1)
          ], undefined, true),
          _: 1
        }),
        _createVNode(_component_Typography, { variant: "caption" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.formatScore(
                            _ctx.userData.scorecard_score.value,
                            false,
                            false,
                            'nps',
                            _ctx.$companyVars?.decimals
                        )) + " " + _toDisplayString(_ctx.userData.scorecard_score.type), 1)
          ], undefined, true),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_Typography, { variant: "h4" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.scoreChange), 1)
            ], undefined, true),
            _: 1
          }),
          _createVNode(_component_Typography, { variant: "caption score-up-down" }, {
            default: _withCtx(() => [
              _createVNode(_component_UpDownArrow, { positive: _ctx.isScoreChangePositive }, null, 8, ["positive"])
            ], undefined, true),
            _: 1
          })
        ]),
        _createVNode(_component_Typography, {
          variant: "caption",
          class: "percent"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(Math.round(_ctx.userData.previous_term_data.score)) + "% ", 1),
            _createVNode(_component_FontAwesomeIcon, {
              icon: _ctx.faArrowRight,
              class: _normalizeClass({
                            red: !_ctx.isScoreChangePositive,
                            green: _ctx.isScoreChangePositive,
                        })
            }, null, 8, ["icon", "class"]),
            _createElementVNode("span", _hoisted_7, _toDisplayString(Math.round(_ctx.userData.current_term_data.score)) + "%", 1)
          ], undefined, true),
          _: 1
        })
      ])
    ]),
    _createVNode(_component_Typography, {
      variant: "caption",
      class: "last-session"
    }, {
      default: _withCtx(() => [
        (_ctx.userData.last_visited)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createTextVNode(" last session: " + _toDisplayString(_ctx.relativeDate(_ctx.userData.last_visited)), 1)
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createTextVNode(" last session: Never ")
            ], 64))
      ], undefined, true),
      _: 1
    }),
    _createElementVNode("div", {
      class: _normalizeClass({ 'border-bottom': _ctx.totalTopicCount > 0 })
    }, [
      _hoisted_8,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.themeData, (theme, themeIdx) => {
        return (_openBlock(), _createElementBlock("div", {
          key: themeIdx,
          class: "data-row"
        }, [
          _createVNode(_component_Typography, { variant: "body1" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(theme.name), 1)
            ], undefined, true),
            _: 2
          }, 1024),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_Typography, { variant: "subtitle1" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.formatScore(
                                theme.current_term_data.score,
                                false,
                                false,
                                'nps',
                                _ctx.$companyVars?.decimals
                            )), 1)
              ], undefined, true),
              _: 2
            }, 1024),
            _createVNode(_component_Typography, { variant: "caption" }, {
              default: _withCtx(() => [
                _createVNode(_component_UpDownArrow, {
                  positive: theme.change_in_term_data.score > 0
                }, null, 8, ["positive"])
              ], undefined, true),
              _: 2
            }, 1024)
          ])
        ]))
      }), 128))
    ], 2),
    (_ctx.totalTopicCount > 0)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _hoisted_10,
          (_ctx.getTopTopic)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createVNode(_component_Typography, { variant: "body1" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.getTopTopic.displayName), 1)
                  ], undefined, true),
                  _: 1
                }),
                _createVNode(_component_Typography, { variant: "body1" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.formatScore(
                            _ctx.getTopTopic.nps,
                            false,
                            false,
                            'nps',
                            _ctx.$companyVars?.decimals
                        )) + " ", 1),
                    _renderSlot(_ctx.$slots, "default", {}, () => [
                      _createVNode(_component_UpDownArrow, {
                        positive: _ctx.getTopTopic.change > 0
                      }, null, 8, ["positive"])
                    ], true)
                  ], undefined, true),
                  _: 3
                })
              ]))
            : _createCommentVNode("", true),
          (_ctx.getWorstTopic && _ctx.getTopTopic !== _ctx.getWorstTopic)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createVNode(_component_Typography, { variant: "body1" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.getWorstTopic.displayName), 1)
                  ], undefined, true),
                  _: 1
                }),
                _createVNode(_component_Typography, { variant: "body1" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.formatScore(
                            _ctx.getWorstTopic.nps,
                            false,
                            false,
                            'nps',
                            _ctx.$companyVars?.decimals
                        )) + " ", 1),
                    _renderSlot(_ctx.$slots, "default", {}, () => [
                      _createVNode(_component_UpDownArrow, {
                        positive: _ctx.getWorstTopic.change > 0
                      }, null, 8, ["positive"])
                    ], true)
                  ], undefined, true),
                  _: 3
                })
              ]))
            : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_13, [
      _createVNode(_component_RainBaseButton, {
        variant: "secondary",
        full: "",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (
                    _ctx.router
                        .push({
                            name: 'scorecardHomeUser',
                            params: { teamMemberUserId: _ctx.userData.id },
                        })
                        .catch((e) => e)
                ))
      }, {
        default: _withCtx(() => [
          _createTextVNode(" View Scorecard ")
        ], undefined, true),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createVNode(_component_RainBaseButton, {
        variant: "primary",
        full: "",
        onClick: _ctx.onMessageUser
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Message " + _toDisplayString(_ctx.userData.name), 1)
        ], undefined, true),
        _: 1
      }, 8, ["onClick"])
    ])
  ]))
}